import {Component, OnDestroy} from '@angular/core';
import {CommonModule} from '@angular/common';
import {MatToolbarModule} from "@angular/material/toolbar";
import {LoadingService} from "projects/nter-ui-kit/src/lib/framework/util/service/loading.service";
import {
  AdminContextSelectorComponent
} from "projects/admin-portal/src/app/pages/admin-panel/admin-context-selector/admin-context-selector.component";
import {MatMenuModule} from "@angular/material/menu";
import {Observable} from "rxjs";
import {AuthenticationService} from "projects/nter-ui-kit/src/lib/framework/security/service/authentication.service";
import {CustomIconService} from "projects/admin-portal/src/app/config/custom-icon.service";
import {BreadcrumbService} from "projects/nter-ui-kit/src/lib/framework/util/service/breadcrumb.service";
import {
  ProcessingDialogService
} from "projects/nter-ui-kit/src/lib/webkit/components/processing-dialog/processing-dialog.service";
import {MatIconModule} from "@angular/material/icon";
import {RouterLink} from "@angular/router";
import {MatButtonModule} from "@angular/material/button";

@Component({
  selector: 'app-navbar',
  standalone: true,
  imports: [
    CommonModule,
    MatToolbarModule,
    AdminContextSelectorComponent,
    MatMenuModule,
    MatIconModule,
    RouterLink,
    MatButtonModule
  ],
  templateUrl: './site-navbar.component.html',
  styleUrls: ['site-navbar.component.scss']
})
export class SiteNavbarComponent implements OnDestroy {
  protected loading$ = this.loader.loading$;
  protected date: Date = new Date();
  protected breadcrumbs$: Observable<string>;
  protected loggedIn$: Observable<boolean>;

  constructor(private loader: LoadingService,
              private authenticationService: AuthenticationService,
              private iconService: CustomIconService,
              private breadcrumbService: BreadcrumbService,
              private processingDialogService: ProcessingDialogService
  ) {
    this.iconService.loadSvgIcons(['brand-logo', 'brand-icon-alt-1']);
    this.breadcrumbs$ = this.breadcrumbService.getBreadcrumbs();
    this.loggedIn$ = this.authenticationService.isLoggedIn;
  }

  protected logout(): void {
    this.processingDialogService.open();
    this.authenticationService.logout();
  }

  ngOnDestroy(): void {
    this.processingDialogService.close();
  }
}
